import { render } from "./CartFooterTotal.vue?vue&type=template&id=7d85eef0"
import script from "./CartFooterTotal.vue?vue&type=script&lang=js"
export * from "./CartFooterTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__